//#region src/weekday.ts
var Weekday = /* @__PURE__ */ function(Weekday) {
	Weekday["Sun"] = "sun";
	Weekday["Mon"] = "mon";
	Weekday["Tue"] = "tue";
	Weekday["Wed"] = "wed";
	Weekday["Thu"] = "thu";
	Weekday["Fri"] = "fri";
	Weekday["Sat"] = "sat";
	return Weekday;
}(Weekday || {});
//#endregion
export { Weekday };

//# sourceMappingURL=weekday.js.map